import { useProcessInstance } from 'exacta-material-react/lib/src/hooks';
import QueryString from 'query-string';
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Typography } from '@material-ui/core';

import LoadingProgress from '../../components/LoadingProgess';
import { getLessonDefinition, getResourcesForLesson } from '../../store/actions/resources.actions';
import { RESOURCE_LOADED_STATUS } from '../../store/sagas/resources.saga';
import { Catiz } from '../Catiz';

const CatizLauncher: React.FC = () => {
  const resourcesLoadingStatus = useSelector(
    (state: any) => state.resources.loadingStatus
  );
  const location = useLocation();
  const { unit, version } = QueryString.parse(location.search);
  const dispatch = useDispatch();
  const executorResources = useSelector((state: any) => state.resources);
  const trainingUnit = useProcessInstance(unit, 'NotsTrainingUnitDefinition');
  const lessonDef = executorResources.lessonDefinition;
  const { t } = useTranslation();
  useEffect(() => {
    if (!lessonDef && trainingUnit && version) {
      dispatch(getLessonDefinition({ trainingUnit, version }));
    }
  }, [trainingUnit, version]);

  useEffect(() => {
    if (lessonDef) {
      dispatch(
        getResourcesForLesson({
          resources: lessonDef.requiredComponents,
          lessonId: lessonDef.id,
        })
      );
    }
  }, [lessonDef]);

  // if (!unit || !version) {
  //   return (
  //     <Typography>Looks like you have opened the url directly.</Typography>
  //   );
  // }
  // if (!lessonDef || !resourcesLoadingStatus[lessonDef.id]) {
  //   return <LoadingProgress message={t('loadingProgress.player')} />;
  // }
  // if (resourcesLoadingStatus[lessonDef.id] === RESOURCE_LOADED_STATUS.FAILED) {
  //   return <p>Failed loading resources</p>;
  // }
  return (
    <Fragment>
      <Catiz lessonDef={lessonDef} />
    </Fragment>
  );
};

export default CatizLauncher;
